/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  GET_YES_NO_CODETABLE,
  GET_CODETABLES_BY_TABLE_NAME,
  GET_NOTIFICATION_TYPE_CODETABLE,
  GET_GENDER_CODETABLE,
  GET_STATE_CODETABLE,
} from './actionTypes';

/**
 * Updates the details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getYesNoCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_YES_NO_CODETABLE);

/**
 * Updates the indicator of creation of details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetYesNoCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_YES_NO_CODETABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getYesNoCodetableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_YES_NO_CODETABLE);

/**
 * Updates the details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getCodetablesByTableNameReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the indicator of creation of details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetCodetablesByTableNameReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getCodetablesByTableNameErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getNotificationTypeCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_NOTIFICATION_TYPE_CODETABLE);

/**
 * Updates the indicator of creation of details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetNotificationTypeCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_NOTIFICATION_TYPE_CODETABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getNotificationTypeCodetableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_NOTIFICATION_TYPE_CODETABLE);

/**
 * Updates the details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getGenderCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_GENDER_CODETABLE);

/**
 * Updates the indicator of creation of details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetGenderCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_GENDER_CODETABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getGenderCodetableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_GENDER_CODETABLE);

/**
 * Updates the details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getStateCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_STATE_CODETABLE);

/**
 * Updates the indicator of creation of details in the 'SDCodeTableService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetStateCodetableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_STATE_CODETABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getStateCodetableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_STATE_CODETABLE);

const reducers = combineReducers({
  getYesNoCodetable: getYesNoCodetableReducer,

  isFetchingGetYesNoCodetable: isFetchingGetYesNoCodetableReducer,
  getYesNoCodetableError: getYesNoCodetableErrorReducer,

  getCodetablesByTableName: getCodetablesByTableNameReducer,

  isFetchingGetCodetablesByTableName: isFetchingGetCodetablesByTableNameReducer,
  getCodetablesByTableNameError: getCodetablesByTableNameErrorReducer,

  getNotificationTypeCodetable: getNotificationTypeCodetableReducer,

  isFetchingGetNotificationTypeCodetable: isFetchingGetNotificationTypeCodetableReducer,
  getNotificationTypeCodetableError: getNotificationTypeCodetableErrorReducer,

  getGenderCodetable: getGenderCodetableReducer,

  isFetchingGetGenderCodetable: isFetchingGetGenderCodetableReducer,
  getGenderCodetableError: getGenderCodetableErrorReducer,

  getStateCodetable: getStateCodetableReducer,

  isFetchingGetStateCodetable: isFetchingGetStateCodetableReducer,
  getStateCodetableError: getStateCodetableErrorReducer,
});

export default { reducers };
